import { Button, PlusIcon } from "melco-ui";



type UserAddProfileButtonProps = {

  setIsAddProfileDrawerOpenAction: (v: boolean) => void
};

export const UserAddProfileButton: React.FC<
  UserAddProfileButtonProps
> = ({ setIsAddProfileDrawerOpenAction }) => {

  // const { t } = useTranslation();
  return (
    <>
      {
        <Button
          key="user-add-profile"
          type="primary"
          icon={<PlusIcon />}
          onClick={async () => {

            setIsAddProfileDrawerOpenAction(true);
          }}

        >
          Create New User
        </Button>
      }
    </>


  );
};
